// Módulo CROSS "tour" — persistencia contra lealify-base (users.tours, cruza
// dispositivos). Endpoints genéricos compartidos por todas las verticales.

export const markTourSeen = async (
  key: string,
  meta?: { completed?: boolean; lastStep?: number }
): Promise<void> => {
  try {
    await fetch(`/api/me/tours/${encodeURIComponent(key)}/seen`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(meta || {}),
    });
  } catch {
    /* best-effort: no bloquear la app por el marcador */
  }
};

export const resetTourSeen = async (key: string): Promise<void> => {
  try {
    await fetch(`/api/me/tours/${encodeURIComponent(key)}`, {
      method: 'DELETE',
      credentials: 'include',
    });
  } catch {
    /* best-effort */
  }
};
